<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-signature mr-2"></i>
                            Assinar {{ titulo }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div v-if="!lista_opcoes_certificado || !lista_opcoes_certificado.length">
                            <div v-if="lista_certs === null">
                                <div class="spinner-border spinner-border-sm mr-3" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                Carregando opções de certificado...
                            </div>
                            
                            <div class="alert alert-warning" v-else>
                                <i class="fas fa-exclamation-triangle mr-2"></i>
                                Nenhum certificado disponível para assinatura.
                            </div>
                        </div>

                        <div class="form-row mb-3">
                            <div class="col col-12">
                                <az-input
                                    type="button-group"
                                    :optionsList="lista_opcoes_certificado"
                                    optionsDisplay="search"
                                    optionsData="id"
                                    v-model="tipo_certificado" />
                            </div>
                        </div>

                        <template v-if="tipo_certificado == 'certificado'">
                        
                            <input 
                                type="text" 
                                id="password" 
                                style="-webkit-text-security: disc;" 
                                v-model="chave" 
                                autocomplete="off"
                                class="form form-control" />

                            <az-input
                                label="Chave"
                                v-model="chave"
                                v-if="1 == 0"
                                :validate="validate" 
                                icon="fas fa-eye"
                                :buttonIcon="true"
                                buttonText="fas fa-eye"
                                @clickButton="show_password = !show_password"
                                :type="show_password ? 'text' : 'password'" />

                        </template>

                        <template v-else-if="tipo_certificado == 'vidaas'">

                            <div v-if="url_aut">

                                <div class="alert alert-success" v-if="vidas_autenticado">
                                    <i class="fas fa-check mr-2"></i>
                                    <div>
                                        Autorização via QR Code do VIDaaS realizada com sucesso.
                                    </div>
                                </div>

                                <div class="alert alert-info" v-else>
                                    <div class="spinner-border spinner-border-sm mr-3" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    Aguardando Autorização via QR Code do VIDaaS.
                                </div>

                            </div>
                            
                            <div>
                                <a href="https://portal.cfm.org.br/noticias/cfm-inova-e-oferece-certificacao-digital-gratuito-aos-medicos-brasileiros" target="_blank">
                                    Saiba mais sobre o Certificado VIDaaS
                                </a>
                            </div>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                        <az-submit @click="assinar ()">Assinar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import { subscribe, unSubscribe } from "../../../service/Notify.js";

export default {
    data () { 
        return { 
            chave: "",
            validate: false, 
            id_anamnese: null,
            model: null,
            id: null, 
            callback: null, 
            show_password: false,
            exibir_campo_senha: false,
            modal_chave: "", 
            tipo_certificado: "certificado",
            url_aut: null, 
            chave_vidaas: null,
            vidas_autenticado: false, 
            vidaas_ativado: null, 
            lista_certs: null, 
        }
    },

    components: { 
        AzSubmit,
        AzInput, 
    },

    computed: { 
        lista_opcoes_certificado: function () { 
            if ( this.model == 'solicAutLea' ) { 
                return [
                    { search: 'Certificado Digital', id: 'certificado' },
                ];
            } else { 
                return this.lista_certs ? this.lista_certs : [];
            }
        },

        modal_name: function () { 
            return 'assinarPepModal' + this.modal_chave;
        },

        titulo: function() { 
            if ( this.model == 'documentoPreAtendimento' ) { 
                return 'Documento';
            } else if ( this.model == 'solicAutLea' ) { 
                return 'Solitação de Autorização (LEA)';
            } 

            return this.model;
        }
    },

    props: ['tem_certificado'], 

    methods: { 
        
        fechar() { 
            this.exibir_campo_senha = false;
            $('#' + this.modal_name).modal('hide');
        },

        solicitar (id_anamnese, model, id, callback) { 

            if ( this.lista_certs === null ) { 

                if ( this.tem_certificado ) { 
                    this.lista_certs = [
                        { search: 'Certificado Digital', id: 'certificado' },
                    ];
                    this.tipo_certificado = 'certificado';
                }

                this.$util.loadItem(this, { 
                    service: 'pep',
                    func: 'lista_certificados',
                    parms: { 
                        tem_certificado: this.tem_certificado,
                    }
                })
                .then(res => { 
                    this.lista_certs = res;
                    this.tipo_certificado = res.length ? res[0].id : '?';
                });

            }

            this.validate = false;
            this.id_anamnese = id_anamnese;
            this.model = model;
            this.id = id;
            this.callback = callback;
            this.exibir_campo_senha = true;

            $('#' + this.modal_name).modal('show');
        },

        assinar () { 

            if ( !this.lista_opcoes_certificado.length ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Nenhum certificado disponível para assinatura.",
                    life: 3000
                });
                return;
            }

            let chave = this.chave;
            //this.chave = "";
            //this.exibir_campo_senha = false;
            
            this.$nextTick(() => { 

                if ( this.model == 'solicAutLea' ) { 

                    this.$store.commit("loading", true);

                    this.axios.post(
                        'imprimir/assinar_lea/' + this.id,
                        {
                            chave: chave
                        },
                    )
                    .then(res => {
                        if(res && res.data && res.data.status_code && res.data.status_code >= 400) {
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: res.data.msg ? res.data.msg : 'Erro ao assinar LEA',
                                life: 3000
                            });
                            return;
                        }

                        let userData = this.$store.state.user;
                        userData.chave = chave;

                        this.$store.commit("setUser", userData);

                        $('#' + this.modal_name).modal('hide');

                        this.callback ();
                    })
                    .final(() => { 
                        this.$store.commit("loading", false);
                    });

                    return;

                }

                if ( this.tipo_certificado == 'vidaas' ) { 
                    this.chave_vidaas = 'vidaas-' + this.$util.uuidv4();
                }

                this.$util.atualizar(this, { 
                    service: 'pep',
                    func: 'assinar',
                    redir_api: true, 
                    dados: { 
                        id_anamnese: this.id_anamnese,
                        model_type: this.model,
                        model_id: this.id,
                        chave: chave, 
                        tipo_certificado: this.tipo_certificado,
                        chave_vidaas: this.chave_vidaas,
                    },
                    callback: res => { 

                        if ( res && res.url_aut ) { 

                            subscribe(this.$store.state.dominio, this.chave_vidaas, (retorno) => {
                                if ( retorno && retorno.data && retorno.data.status == 'success' ) { 
                                    this.vidas_autenticado = true;    
                                    unSubscribe(this.$store.state.dominio, this.chave_vidaas);
                                }
                            });

                            this.vidas_autenticado = false; 
                            this.url_aut = res.url_aut;
                            window.open(this.url_aut, '_blank');

                            return;

                        }

                        /*
                        if ( process.env.VUE_APP_GTAG ) { 

                            let action = 'assinar-documento';
                            let label = this.$store.state.user.st_login + ' / ' + this.model + '-' + this.id;

                            this.$gtag.event(action, {
                                'event_category': window.redir,
                                'event_label': label,
                                'value': 1
                            });

                        }
                        */

                        //this.exibir_campo_senha = false;
                        //this.chave = chave;

                        let userData = this.$store.state.user;
                        userData.chave = chave;

                        this.$store.commit("setUser", userData);

                        this.fechar();

                        this.callback ();
                    },
                });

            });

        },

    },

    mounted() { 
        this.chave = this.$store.state.user.chave;
        this.modal_chave = this.$util.uuidv4();
    }
}
</script>